import { render, staticRenderFns } from "./FeedbackTableComponent.vue?vue&type=template&id=5291c95d&scoped=true&"
import script from "./FeedbackTableComponent.vue?vue&type=script&lang=js&"
export * from "./FeedbackTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTableComponent.vue?vue&type=style&index=0&id=5291c95d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291c95d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VIcon,VRating,VRow,VTextField})
